import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import common from "./locales/en/common.json";
import games from "./locales/en/games.json";
import dashboard from "./locales/en/dashboard.json";
import toasts from "./locales/en/toasts.json";
import metadata from "./locales/en/metadata.json";
import friends from "./locales/en/friends.json";
import wallet from "./locales/en/wallet.json";

const resources = {
  en: {
    common,
    games,
    dashboard,
    toasts,
    metadata,
    friends,
    wallet,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en"],
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    ns: [
      "common",
      "games",
      "dashboard",
      "toasts",
      "metadata",
      "friends",
      "wallet",
    ],
    defaultNS: "common",
    react: {
      useSuspense: true,
    },
  });

export default i18n;
